class _Settings {
  ctpConfig() {
    return { ..._Settings.COMMERCE_SETTINGS }
  }

  einzaApiConfig() {
    return { ..._Settings.EINZA_API_SETTINGS }
  }

  einzaGraphiQLConfig() {
    return { ..._Settings.EINZA_GRAPHIQL_SETTINGS }
  }

  algoliaConfig() {
    return { ..._Settings.ALGOLIA_SETTINGS }
  }

  authsignalConfig() {
    return { ..._Settings.AUTHSIGNAL_SETTINGS }
  }

  isIdmApp() {
    return process.env.NEXT_PUBLIC_IS_IDM_APP === "true"
  }

  sanityConfigByLang(lang = "de-DE") {
    return _Settings.CONFIG_LANG_MAP[lang]
      ? _Settings.CONFIG_LANG_MAP[lang].cms
      : Object.values(_Settings.CONFIG_LANG_MAP)[0].cms
  }

  baseUrl() {
    const fallbackBaseUrl = process.env.VERCEL_URL
      ? `https://${process.env.VERCEL_URL}`
      : typeof window !== "undefined"
        ? window.location.origin
        : "http://localhost:3000"

    return process.env.NEXT_PUBLIC_WWW_DOMAIN || fallbackBaseUrl
  }

  locales() {
    return Object.keys(_Settings.CONFIG_LANG_MAP)
  }

  defaultLocale() {
    const defaultLocale = Object.entries(_Settings.CONFIG_LANG_MAP)
      .filter(([, config]) => {
        return config.default === true
      })
      .slice(0, 1)[0]

    return defaultLocale ? defaultLocale[0] : null
  }

  fqlUri() {
    const path = process.env.NEXT_PUBLIC_FRONTEND_GRAPHQL_URI

    if (typeof window !== "undefined") {
      return path
    }

    return `${this.baseUrl()}${path}`
  }

  targetEnv() {
    return process.env.NEXT_PUBLIC_TARGET_ENV || "development"
  }
  getPossibleTargetEnvs() {
    return [..._Settings.TARGET_ENVS]
  }

  getAuthRoutesFromLocale(locale) {
    const localeToUse = locale ?? this.defaultLocale()

    const authRoutes = [
      `/${localeToUse}/auth/signin`,
      `/${localeToUse}/auth/signin/redirect`,
      `/${localeToUse}/auth/forgot-password`,
      `/${localeToUse}/auth/reset-password`,
    ]

    return authRoutes
  }

  mailerConfig() {
    return { ..._Settings.MAILER_SETTINGS }
  }

  getAuthsignalEnv() {
    return {
      tenantId: process.env.NEXT_PUBLIC_AUTHSIGNAL_TENANT_ID,
      baseUrl: process.env.NEXT_PUBLIC_AUTHSIGNAL_BASE_URL,
    }
  }

  whitelistedIps() {
    return _Settings.WHITELISTED_IPS
  }

  static MAILER_SETTINGS = {
    appUrl: process.env.ADM_APP_URL,
    msGraphClientId: process.env.MAILER_MSGRAPH_CLIENT_ID?.trim(),
    msGraphTenantId: process.env.MAILER_MSGRAPH_TENANT_ID?.trim(),
    msGraphClientSecret: process.env.MAILER_MSGRAPH_CLIENT_SECRET?.trim(),
    msGraphUser: process.env.MAILER_MSGRAPH_USER?.trim(),
    msGraphSaveToSentItems: (() => {
      const saveRaw = process.env.MAILER_MSGRAPH_SAVE_TO_SENT_ITEMS?.trim().toLowerCase()
      return saveRaw === undefined || saveRaw === "" ? true : !["0", "false", "no"].includes(saveRaw)
    })(),
  }

  static CONFIG_LANG_MAP = {
    "de-DE": {
      cms: {
        dataset:
          process.env.NEXT_PUBLIC_SANITY_CONFIG_DE_DE?.split(",")[1] ||
          process.env.STORYBOOK_SANITY_CONFIG_DE_DE?.split(",")[1],

        projectId:
          process.env.NEXT_PUBLIC_SANITY_CONFIG_DE_DE?.split(",")[0] ||
          process.env.STORYBOOK_SANITY_CONFIG_DE_DE?.split(",")[0],
        apiVersion: "2026-05-27",
        token: process.env.SANITY_API_TOKEN,
        useCdn: true,
      },

      default: true,
    },
    "en-DE": {
      cms: {
        dataset: process.env.NEXT_PUBLIC_SANITY_CONFIG_EN_DE?.split(",")[1],

        projectId: process.env.NEXT_PUBLIC_SANITY_CONFIG_EN_DE?.split(",")[0],
        apiVersion: "2026-05-27",
        token: process.env.SANITY_API_TOKEN,
        useCdn: true,
      },
    },
  }

  static COMMERCE_SETTINGS = {
    projectKey: process.env.CTP_PROJECT_KEY,
    clientSecret: process.env.CTP_CLIENT_SECRET,
    clientID: process.env.CTP_CLIENT_ID,
    authUrl: process.env.CTP_AUTH_URL,
    apiUrl: process.env.CTP_API_URL,
    scopes: process.env.CTP_SCOPES?.split(" ") ?? [],
    cartIgnoreBeforeUtc: process.env.CART_IGNORE_BEFORE_UTC,
  }

  static EINZA_API_SETTINGS = {
    apiPassword: process.env.EINZA_API_PASSWORD,
    apiUser: process.env.EINZA_API_USER,
    apiEndpoint: process.env.EINZA_API_ENDPOINT,
  }

  static EINZA_GRAPHIQL_SETTINGS = {
    graphiQLToken: process.env.EINZA_GRAPHIQL_TOKEN,
    graphiQLEndpoint: process.env.EINZA_GRAPHIQL_ENDPOINT,
    graphiQLDocumentEndpoint: process.env.EINZA_GRAPHIQL_DOCUMENT_ENDPOINT,
  }

  static TARGET_ENVS = ["development", "staging", "production"]

  static ALGOLIA_SETTINGS = {
    appID: process.env.ALGOLIA_APP_ID,
    apiKey: process.env.ALGOLIA_APP_API_KEY,
  }

  static AUTHSIGNAL_SETTINGS = {
    appUrl: process.env.NEXT_PUBLIC_AUTHSIGNAL_BASE_URL,
    apiKeySecret: process.env.AUTHSIGNAL_TENANT_SECRET,
    mfaDisabled: process.env.MFA_DISABLED === "true",
    mfaWhitelistedIps: process.env.MFA_IGNORE_IPS?.split(",") || [],
  }

  static WHITELISTED_IPS = process.env.WHITELISTED_IPS?.split(",") || []
}

export const AppSettings = new _Settings()
